import { isSearchQueryParameter } from '~~/helpers/typesense/isSearchQueryParameter';
import type { ParsedQs } from 'qs';

export default function (params: ParsedQs): ParsedQs {

  return Object.keys(params)
    .filter(key => isSearchQueryParameter(key))
    .reduce((accumulator: ParsedQs, key) => {

      const value = params[key];

      if (value !== undefined) {

        accumulator[key] = value;

      }

      return accumulator;

    }, {});

}
